var Berkalkulator = Berkalkulator || {};

Berkalkulator.FamilyCalculator = (function() {
    var fieldsToIgnoreInPath = ['amount', 'secondAmount', 'csrf'];
    var breakDownChart;
    var year;

    $(function() {
        $('#eltartottakSzama').on('change', function() {
            setChildrenBasedVisibility();
        });

        setChildrenBasedVisibility();
    });

    var initChart = function(chartValues) {
        $( "#breakDownChart" ).remove();
        year = chartValues.year;
        if (chartValues.netto == 0) {
            $('.container-donut-chart').addClass('hidden');
            return;
        }

        $('.container-donut-chart').removeClass('hidden');
        $('.donut-chart-block').prepend('<canvas id="breakDownChart" height="200"></canvas>');
        var ctx = $('#breakDownChart').get(0).getContext('2d');
        var options = {
            segmentShowStroke : true,
            segmentStrokeColor : "#fff",
            segmentStrokeWidth : 2,
            percentageInnerCutout : 70, // This is 0 for Pie charts
            animationSteps : 100,
            animationEasing : "easeOutBounce",
            animateRotate : true,
            animateScale : false,
            showTooltips: false
        };
        var data = [
            {
                value: chartValues.netto,
                color: "#23c6c8",
                highlight: "#23c6c8",
                label: "Nettó havi munkabér"
            },
            {
                value: chartValues.levonas,
                color:"#e64c65",
                highlight: "#e64c65",
                label: "Havi összes levonás a bruttó bérből"
            }
        ];
        breakDownChart = new Chart(ctx).Pie(data,options);

        $('#highlighted-bruttoHaviMunkaber').html(numberWithSpaces(chartValues.brutto) + ' Ft');
        $('.list-nettoHaviMunkaber .breakdown-item').html(numberWithSpaces(chartValues.netto) + ' Ft');
        $('.list-haviOsszesLevonasBruttoBerbol .breakdown-item').html(numberWithSpaces(chartValues.levonas) + ' Ft');
    };

    var resetChildrenBased = function() {
        $('#kedvezmenyezettEltartottakSzama').val('0');
    };

    var setChildrenOptions = function(selector, maxValue) {
        $(selector + ' option').each(function() {
            if (parseInt(this.value) <= parseInt(maxValue)) {
                //$(this).removeAttr('disabled');
                $(this).show();
            } else {
                //$(this).attr('disabled','disabled');
                $(this).hide();
            }
        });
    };

    var setChildrenBasedVisibility = function() {
        var selected = $('#eltartottakSzama').val();

        if (selected < $('#kedvezmenyezettEltartottakSzama').val()) {
            $('#kedvezmenyezettEltartottakSzama').val(selected);
        }

        if (selected == 0) {
            $('.onlyWithChildren').hide();
            $('#gyereketEgyedulNevelo').attr('checked', false);
            resetChildrenBased();
        } else {
            $('.onlyWithChildren').show();
            setChildrenOptions('#kedvezmenyezettEltartottakSzama', selected);
        }
    };

    var numberWithSpaces = function(x) {
        return parseInt(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    var updateResult = function(result) {

        $('#magasabbBruttoHaviMunkaber').html(numberWithSpaces(result.magasabbBruttoHaviMunkaber) + ' Ft');
        $('#alacsonyabbBruttoHaviMunkaber').html(numberWithSpaces(result.alacsonyabbBruttoHaviMunkaber) + ' Ft');
        $('.calculationResult #eltartottakSzama').html(result.firstCalculatorResult.eltartottakSzama);
        $('.calculationResult #kedvezmenyezettEltartottakSzama').html(result.firstCalculatorResult.kedvezmenyezettEltartottakSzama);

        for(i = 0; i < 2; i++) {
            var rowData = (i == 0 ? result.firstCalculatorResult : result.secondCalculatorResult);
            var item = '-' + i;
            $('.bruttoHaviMunkaber' + item).html(numberWithSpaces(rowData.bruttoHaviMunkaber) + ' Ft');
            $('.evesBruttoJovedelem' + item).html(numberWithSpaces(rowData.evesBruttoJovedelem) + ' Ft');
            $('.calculationResult .eltartottakSzama' + item).html(rowData.eltartottakSzama);
            $('.calculationResult .kedvezmenyezettEltartottakSzama' + item).html(rowData.kedvezmenyezettEltartottakSzama);
            $('.szocialisHozzajarulasiAdo' + item).html(numberWithSpaces(rowData.szocialisHozzajarulasiAdo) + ' Ft');
            $('.szakkepzesiHozzajarulas' + item).html(numberWithSpaces(rowData.szakkepzesiHozzajarulas) + ' Ft');
            $('.munkaeroPiaciJarulek' + item).html(numberWithSpaces(rowData.munkaeroPiaciJarulek) + ' Ft');
            $('.egeszsegbiztositasiJarulek' + item).html(numberWithSpaces(rowData.egeszsegbiztositasiJarulek) + ' Ft');
            $('.nyugdijJarulek' + item).html(numberWithSpaces(rowData.nyugdijJarulek) + ' Ft');
            $('.tarsadalombiztositasiJarulek' + item).html(numberWithSpaces(rowData.tarsadalombiztositasiJarulek) + ' Ft');
            $('.gyes' + item).html(numberWithSpaces(rowData.gyes) + ' Ft');
            $('.csaladiAdokedvezmeny' + item).html(numberWithSpaces(rowData.csaladiAdokedvezmeny) + ' Ft');
            $('.frissHazasokAdokedvezmenye' + item).html(numberWithSpaces(rowData.frissHazasokAdokedvezmenye) + ' Ft');
            $('.szamitottSZJA' + item).html(numberWithSpaces(rowData.szamitottSZJA) + ' Ft');
            $('.csaladiAdokedvezmennyelCsokkentettSZJA' + item).html(numberWithSpaces(rowData.csaladiAdokedvezmennyelCsokkentettSZJA) + ' Ft');
            $('.felNemHasznaltCsaladiAdokedvezmeny' + item).html(numberWithSpaces(rowData.felNemHasznaltCsaladiAdokedvezmeny) + ' Ft');
            $('.osszesAdo' + item).html(numberWithSpaces(rowData.osszesAdo) + ' Ft');
            $('.adojovairas' + item).html(numberWithSpaces(rowData.adojovairas) + ' Ft');
            $('.felhasznaltOsszesMunkavallaloiKedvezmeny' + item).html(numberWithSpaces(rowData.felhasznaltOsszesMunkavallaloiKedvezmeny) + ' Ft');
            $('.haviOsszesLevonasBruttoBerbol' + item).html(numberWithSpaces(rowData.haviOsszesLevonasBruttoBerbol) + ' Ft');
            $('.haviOsszesMunkaadoiKedvezmeny' + item).html(numberWithSpaces(rowData.haviOsszesMunkaadoiKedvezmeny) + ' Ft');
            $('.haviOsszesMunkaadoiJarulek' + item).html(numberWithSpaces(rowData.haviOsszesMunkaadoiJarulek) + ' Ft');
            $('.osszesenHavontaAllamnakFizetendo' + item).html(numberWithSpaces(rowData.osszesenHavontaAllamnakFizetendo) + ' Ft');
            $('.munkaadoOsszesHaviKoltsege' + item).html(numberWithSpaces(rowData.munkaadoOsszesHaviKoltsege) + ' Ft');
            $('.nettoHaviMunkaber' + item).html(numberWithSpaces(rowData.nettoHaviMunkaber) + ' Ft');
            $('.csaladiPotlek' + item).html(numberWithSpaces(rowData.csaladiPotlek) + ' Ft');
            $('.haviOsszesNettoJovedelem' + item).html(numberWithSpaces(rowData.haviOsszesNettoJovedelem) + ' Ft');
        }

        var el = $('.calculationResult');
        var newone = el.clone(true);
        el.before(newone);
        $(".calculationResult:last").remove();
        initChart({
            brutto: result.osszesBrutto,
            netto: result.osszesNetto,
            levonas: result.osszesLevonas,
            year: year
        });
        newone.removeClass('pulse').addClass('pulse');
    };

    var updateHistory = function(parameters, result, currentYear) {
        var amount = $('#amount').val();
        var secondAmount = $('#secondAmount').val();

        var params = '';
        parameters.forEach(function(item) {
            if (fieldsToIgnoreInPath.indexOf(item.name) > -1 || item.value == 0) {
                return;
            }

            if (params != '') {
                params += '&';
            }

            params += item.name + '=' + item.value;
        });

        var url = '/csaladi-berkalkulator-' + currentYear + '/' + amount + '-' + secondAmount + '-brutto-fizetes';
        if (params != '') {
            url += '?' + params;
        }

        if (!amount) {
            url = '/csaladi-berkalkulator-' + currentYear;
        }

        $('#fb-like').data('href', url);

        window.history.pushState({
            'parameters' : parameters,
            'result': result
        }, null, url);
    };

    var updateParamaters = function(parameters) {
        parameters.forEach(function(item) {
            $('#' + item.name).val(item.value);
        });
    };

    window.onpopstate = function(e){
        if(e.state){
            updateResult(e.state.result);
            updateParamaters(e.state.parameters);
            setChildrenBasedVisibility();
        }
    };

    var onParametersChanged = function() {
        var a = $("#amount").val();
        var b = $("#secondAmount").val();
        if (isNaN(parseInt(a)) ||  parseInt(a) < 10000 || isNaN(parseInt(b)) || parseInt(b) < 10000) {
            return;
        }

        var formData = $("#calculatorForm").serialize();

        $.ajax({
            method: "POST",
            url: "/api/familycalculate/" + year,
            data: formData,
            cache: false
        })
            .done(function(data) {
                if (data.success === true) {
                    updateResult(data.result);
                    updateHistory($("#calculatorForm").serializeArray(), data.result, year);
                }
            });
    };

    var typingTimer;
    var doneTypingInterval = 1000;
    var $input = $('#amount,#secondAmount');

    var init = function(initialChartValues) {

        initChart(initialChartValues);


        $input.on('input', function() {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(onParametersChanged, doneTypingInterval);
        });

        $input.keypress(function (e) {
            clearTimeout(typingTimer);
            if (e.which == 13) {
                e.preventDefault();
                onParametersChanged();
                return false;
            }
        });

        $('#calcButton').on('click', function() {
            onParametersChanged();
        });

        $('#eltartottakSzama,#kedvezmenyezettEltartottakSzama,#frissHazas').on('change', function() {
            onParametersChanged();
        });
    };

    return {
        Init: init
    };
})();
